import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga';

const biome = {
    getAll: async () => {
        const { data } = await http.get(`${API_PREFIX}/biomes`);
        return data;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}/biomes`, body, {});
    },

    getBiomeDetails: async (id) => {
        const res = await http.get(`${API_PREFIX}/biomes/${id}`);
        return res;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/biomes/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/biomes/${id}`);
    },

    getBiomeAdventures: async (id) => {
        const { data } = await http.get(`${API_PREFIX}/biomes/${id}/adventures`);
        return data;
    },

    getAdventure: async (idBiome, adventureName) => {
        const { data } = await http.get(
            `${API_PREFIX}/adventures-filtering?exceptBiomeId=${idBiome}&adventureName=${adventureName}`,
        );
        return data;
    },

    addAdventure: async (idBiome, idAdventure) => {
        await http.post(`${API_PREFIX}/biomes/${idBiome}/adventures`, {
            idAdventure: idAdventure,
        });
    },

    updateAdventureQty: async (idBiome, idAdventure, qty) => {
        await http.put(`${API_PREFIX}/biomes/${idBiome}/adventures/${idAdventure}`, {
            qty: qty,
        });
    },

    removeAdventure: async (idBiome, idAdventure) => {
        await http.destroy(`${API_PREFIX}/biomes/${idBiome}/adventures/${idAdventure}`);
    },
};

export default biome;
